// src/axios.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  // You can add other configuration settings here
});

export default axiosInstance; 